import React, { useState } from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import UserPaginatedTable from "./table";
import { parsePage } from "components/table";
import { ActionButtons, SearchForm } from "./list-page";

const UserListPage = ({ intl, location: { search } }) => {
  const [filter, setFilter] = useState("");

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.user.list" buttons={<ActionButtons />} />
      <SearchForm onChange={setFilter} />
      <PageSection spaced hideBackground>
        <UserPaginatedTable debounce variables={{ username: filter }} page={parsePage({ queryParams: search })} />
      </PageSection>
    </Dashboard>
  );
};

export default UserListPage;
